import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SEO } from "@/components/SEO";
import { AuthorAvatar } from "@/components/AuthorAvatar";
import InterviewRequestForm from "@/components/InterviewRequestForm";
import { Link } from "react-router-dom";

// Render **bold** markdown to <strong>
function renderMd(text) {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**")
      ? <strong key={i}>{p.slice(2, -2)}</strong>
      : <span key={i}>{p}</span>
  );
}

export default function About() {
  const [me, setMe] = useState(null);
  const [about, setAbout] = useState(null);

  useEffect(() => {
    api.get("/articles").then((r) => {
      const first = r.data.items?.[0];
      if (first) setMe({ id: first.author_id, name: first.author_name, avatar: first.author_avatar });
    });
    api.get("/site/about").then((r) => setAbout(r.data)).catch(() => {});
  }, []);

  const name = me?.name || "Julia Fosah";
  const quote = about?.quote || "";
  const paragraphs = about?.bio_paragraphs || [];
  const principles = about?.principles || [];
  const emailAddr = about?.email || "editor@ittvnews.com";

  return (
    <>
      <SEO title="About · ITTV News" description={`About the newsroom and its founding editor ${name}.`} />

      <div className="container-editorial py-16 md:py-24 reveal">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-7 md:order-1 order-2">
            <div className="kicker text-[color:var(--accent)] mb-3">Founder & Editor</div>
            <h1 className="font-serif text-5xl md:text-7xl font-bold leading-none tracking-tight" data-testid="about-name">
              {name}
            </h1>
            {quote && (
              <p className="mt-8 text-2xl font-serif italic text-[color:var(--text-muted)] leading-snug">
                &ldquo;{quote}&rdquo;
              </p>
            )}
            <div className="mt-10 space-y-6 text-lg leading-relaxed" data-testid="about-paragraphs">
              {paragraphs.map((p, i) => <p key={i}>{renderMd(p)}</p>)}
            </div>
            <div className="mt-10 flex flex-wrap gap-3">
              {me && <Link to={`/author/${me.id}`} className="btn-accent">Read {name.split(" ")[0]}&apos;s stories</Link>}
              <a href={`mailto:${emailAddr}`} className="btn-outline">Get in touch</a>
            </div>
          </div>
          <div className="md:col-span-5 md:order-2 order-1">
            <AuthorAvatar name={name} src={me?.avatar} size="hero" />
          </div>
        </div>
      </div>

      {principles.length > 0 && (
        <div className="bg-[color:var(--surface)] border-y" style={{ borderColor: "hsl(var(--border-hsl))" }}>
          <div className="container-editorial py-16 grid md:grid-cols-3 gap-10" data-testid="about-principles">
            {principles.map((v) => (
              <div key={v.title}>
                <div className="kicker text-[color:var(--accent)] mb-3">Principle</div>
                <div className="font-serif text-4xl font-bold">{v.title}</div>
                <p className="mt-3 text-[color:var(--text-muted)] leading-relaxed">{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="container-editorial py-16">
        <InterviewRequestForm />
      </div>
    </>
  );
}
